import services from './../../services/service'; // Service Class
import SellpointList from '../../components/sellpoint/SellpointList.vue'
import ProductList from '../../components/product/ProductList.vue'
let service = new services();

export default {
    name: 'Sellpoints',
    data () {
        return {
            sellpoints: {},
            img_url: service.imageURL
        }
    },
    components: {
        'sellpoint-list': SellpointList,
        'product-list': ProductList
    },
    methods: {
        getSellpoints() {
            service.getAllBusinesses(this).then(data => {
                if(data.body.status == 200) {
                    this.sellpoints = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                     //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        }

        
    },
    created: function(){
       //this.getSellpoints();
    }

    // created () {
    //   if (this.sellpoints.length === 0) {
    //     this.$store.dispatch('allSellpoints')
    //   }
    // },
    // computed: {
    //   sellpoints () {
    //     return this.$store.getters.allSellpoints
    //   }
    // },
    // data () {
    //   return {

    //   }
    // },
}


// WEBPACK FOOTER //
// ./src/pages/Sellpoints/script.js